export const MINUTES = 'min';
export const HOURS = 'h';
export const DAYS = 'd';
export const MONTHS = 'm';
export const YEARS = 'y';
export const EXPIRY_REGEX = new RegExp(/^([0-9]*)(d|min|m|h|s|y)$/g);
export const MILLISECONDS_IN_MINUTE = 60000;
export const MILLISECONDS_IN_HOUR = MILLISECONDS_IN_MINUTE * 60;
export const MILLISECONDS_IN_DAY = MILLISECONDS_IN_HOUR * 24;
export const MILLISECONDS_IN_YEAR = MILLISECONDS_IN_DAY * 365;
export const EXAMPLE_MESSAGE = `Must be either number representing the expiry date in milliseconds or string with the following possible variations : "14d","2m", "1y", "30min". Time value must be integer and greater than 0.`;
export const ALLOWED_MEASUREMENTS = [
    MINUTES,
    HOURS,
    DAYS,
    MONTHS,
    YEARS,
];
//# sourceMappingURL=constants.js.map